"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructorContext = void 0;

var _react = require("react");

var constructorContext = /*#__PURE__*/(0, _react.createContext)({
  state: {},
  dispatch: function dispatch() {
    return undefined;
  }
});
exports.constructorContext = constructorContext;